const parse = require('url-parse')
import { appCallByPromise, openRouteLink } from '@/utils/app/js-bridge'

export function getCurrentPlatform() {
  const {
    query: { env }
  } = parse(window.location.href, true)
  if (env) {
    return env
  }
  if (window?.webkit?.messageHandlers?.setAction?.postMessage || window?.messageHandlers?.setAction) {
    return 'app'
  }
}
// 安卓系统
export const androidSystem = () => {
  let ua = navigator.userAgent
  return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
}

// ios系统
export const iosSystem = () => {
  let ua = navigator.userAgent
  return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
}

export const isInApp = () => {
  return getCurrentPlatform() === 'app'
}

export const toAppChooseAuthorPage = (parems) => {
  // 如果在 安卓 上
  if (isInApp()) {
    appCallByPromise('qiepian-FiveMin-Auth', parems)
  }
  return isInApp()
}

export const toAppAccreditPage = (id) => {
  // 如果在 app 上
  if (isInApp()) {
    openRouteLink(`cxapp://qiepianThreeStepAuth?id=${id}`)
  }
  return isInApp()
}

export const toAppOrder = () => {
  // 如果在 app 上
  if (isInApp()) {
    openRouteLink(`cxapp://OrderHome`)
  }
}

export const toWangpanPage = (url) => {
  appCallByPromise('open-baiduyun-url', { url })
}
export const toAppWorkBench = () => {
  // 如果在 app 上
  if (isInApp()) {
    openRouteLink(`cxapp://qiepian?tab=1`)
  }
}
